
































































































































































import Component, { mixins } from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import FormValidationMixin from '@/mixins/FormValidationMixin';
import FormInput from '@/components/form/FormInput.vue';
import { Validations } from 'vuelidate-property-decorators';
import { minLength, maxLength, required } from 'vuelidate/lib/validators';
import { ProfileFormData, ProfileResponse } from '@/model/Profile';
import ToastMixin from '@/mixins/ToastMixin';
import isEqual from 'lodash.isequal';

@Component({
    components: {
        FormInput,
    },
})
export default class ProfileForm extends mixins(
    FormValidationMixin,
    ToastMixin,
) {
    @Prop() profileResponse!: ProfileResponse;

    formData = {} as ProfileFormData;

    submitted = false;

    @Watch('profileResponse', { immediate: true })
    watch(): void {
        this.formData = { ...this.profileResponse };
    }

    get isFormDataSameAsCurrentData(): boolean {
        return isEqual(this.profileResponse, this.formData);
    }

    @Validations()
    validations = {
        formData: {
            firstName: {
                required,
                maxLength: maxLength(20),
            },
            lastName: {
                required,
                maxLength: maxLength(20),
            },
            phone: {
                required,
                minLength: minLength(6),
                maxLength: maxLength(15),
                phoneNumber: (value: string | undefined): boolean => {
                    return value?.length
                        ? /^[+]{0,1}[-\s0-9]*$/.test(value)
                        : true;
                },
            },
        },
    };

    @Emit()
    submit(): ProfileFormData | null {
        const request = {
            firstName: this.formData.firstName,
            lastName: this.formData.lastName,
            phone: this.formData.phone,
        };
        return request;
    }

    onSubmit(): void {
        this.submitted = true;
        this.$v.formData.$touch();
        if (!this.$v.$invalid) {
            this.submit();
            this.submitted = false;
        }
    }
}
